import { useJsApiLoader } from '@react-google-maps/api';
import { getEnv } from '../config';

const LIBRARIES = ['places', 'drawing'];

export function useGoogleMapsLoader() {
    return useJsApiLoader({
        googleMapsApiKey: getEnv('REACT_APP_GOOGLE_MAPS_API_KEY') || '',
        libraries: LIBRARIES,
    });
}
